import React from 'react';
import {Field}  from 'redux-form'
import Divider from 'material-ui/Divider';
import Paper from 'material-ui/Paper';

import FormLabel from '../../components/FormLabel'
import FormAutoComplete2 from '../../components/FormAutoComplete2'
import FormDatePicker from '../../components/FormDatePicker'
import styles from '../../styles'

const dataSourceConfig = {
    text: 'textKey',
    value: 'valueKey',
};

class YosanBasicForm extends React.Component {

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    componentDidUpdate() {
    }

    handleNewRequest = (value, index) => {

        const {
            onKenmeiChange,
            kenmeiData
        } = this.props

        if (index === -1) {
            return
        }

        const kenmei = kenmeiData[index] || {}

        onKenmeiChange(
            {
                kenmeiName: kenmei.name,
                branchOfficeName: kenmei.branchOfficeName,
                departmentName: kenmei.departmentName,
                customerName: kenmei.customerName,
                constructionName: kenmei.constructionName,
                address: kenmei.address,
            }
        )

    }

    handleUpdateInput = (value) => {

        const {
            onKenmeiChange,
            kenmeiData
        } = this.props

        const kenmei = kenmeiData.find(x => {
            return x.code == value
        })

        if (kenmei) {
            onKenmeiChange(
                {
                    kenmeiName: kenmei.name,
                    branchOfficeName: kenmei.branchOfficeName,
                    departmentName: kenmei.departmentName,
                    customerName: kenmei.customerName,
                    constructionName: kenmei.constructionName,
                    address: kenmei.address,
                }
            )
        } else {
            onKenmeiChange(
                {
                    kenmeiName: "ー",
                    branchOfficeName: "ー",
                    departmentName: "ー",
                    customerName: "ー",
                    constructionName: "ー",
                    address: "ー",
                }
            )
        }

    }

    render() {

        const {
            kenmeiData,
            userData,
            kenmeiNames,
            status,
        } = this.props

        const kenmeiDataSource = kenmeiData ? kenmeiData.map(x => {
            return {
                textKey: `${x.code} - ${x.name}`,
                valueKey: x.code
            }
        }) : []

        const userDataSource = userData ? userData.map(x => {
            return {
                textKey: `${x.name} - ${x.email}`,
                valueKey: x.name
            }
        }) : []

        return (

            <div className="row" style={{marginBottom: 30}}>
                <div className="col-12">
                    <Paper style={styles.yosanContents}>
                        <h4 style={styles.yosanFormTitle}>件名情報</h4>
                        <Divider/>
                        <div className="row">

                            <div className="col-6">

                                <Field
                                    name="kenmeiCode"
                                    dataSourceConfig={dataSourceConfig}
                                    dataSource={kenmeiDataSource}
                                    component={FormAutoComplete2}
                                    floatingLabelText="件名番号"
                                    filter={(searchText, key) => {
                                        if (searchText == '') {
                                            return true
                                        }
                                        return key.startsWith(searchText)
                                    }}
                                    onNewRequest={this.handleNewRequest}
                                    onUpdateInput={this.handleUpdateInput}
                                    textFieldStyle={{width: '100%'}}
                                    style={{width: '100%'}}
                                    disabled={status === 3}
                                />

                            </div>

                            <div className="col-6">

                                <Field
                                    name="user"
                                    dataSourceConfig={dataSourceConfig}
                                    dataSource={userDataSource}
                                    component={FormAutoComplete2}
                                    floatingLabelText="担当者"
                                    filter={(searchText, key) => {
                                        return searchText !== '' && key.indexOf(searchText) !== -1
                                    }}
                                    textFieldStyle={{width: '100%'}}
                                    style={{width: '100%'}}
                                    disabled={status === 3}
                                />

                            </div>

                        </div>

                        <div className='row'>

                            <div className="col-6">

                                <Field
                                    name="startDate"
                                    component={FormDatePicker}
                                    label="工期（自）"
                                    textFieldStyle={{width: '100%'}}
                                    style={{width: '100%'}}
                                    disabled={status === 3}
                                />
                            </div>
                            {/* <div className="col-2" style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
                  <div style={{ paddingBottom: 7 }}><span style={{ paddingBottom: 5, color: colors.grey600 }}>〜</span></div>
                </div> */}
                            <div className="col-6">
                                <Field
                                    name="endDate"
                                    component={FormDatePicker}
                                    label="工期（至）"
                                    textFieldStyle={{width: '100%'}}
                                    style={{width: '100%'}}
                                    disabled={status === 3}
                                />
                            </div>

                        </div>

                        <div className='row'>

                            <div className="col-8">

                                <FormLabel
                                    title='件名名称'
                                    name='test'
                                    value={kenmeiNames.kenmeiName}
                                />

                            </div>

                        </div>
                        <div className='row'>
                            <div className="col-6">
                                <FormLabel
                                    title='支店'
                                    name='test'
                                    value={kenmeiNames.branchOfficeName}
                                    style={{width: '100%'}}
                                />
                            </div>
                            <div className="col-6">
                                <FormLabel
                                    title='部署'
                                    name='test'
                                    value={kenmeiNames.departmentName}
                                    style={{width: '100%'}}
                                />
                            </div>
                        </div>

                        <div className='row'>
                            <div className="col-6">
                                <FormLabel
                                    title='客先'
                                    name='test'
                                    value={kenmeiNames.customerName}
                                    style={{width: '100%'}}
                                />
                            </div>
                            <div className="col-6">
                                <FormLabel
                                    title='工事種別'
                                    name='test'
                                    value={kenmeiNames.constructionName}
                                    style={{width: '100%'}}
                                />
                            </div>
                        </div>

                        <div className='row'>
                            <div className="col-12">
                                <FormLabel
                                    title='工事現場'
                                    name='test'
                                    value={kenmeiNames.address}
                                    style={{width: '100%'}}
                                />
                            </div>
                        </div>

                    </Paper>

                </div>

            </div>

        );

    }

}

export default YosanBasicForm




// WEBPACK FOOTER //
// ./src/containers/yosan/YosanBasicForm.js